import { gql } from '@apollo/client';

export const QUERY_RESSOURCES_BY_TYPE = gql`
  query findRessourceByTypeId($id: ID!) {
    findRessourceByTypeId(id: $id) {
      name
      desc
      subtitle
      info
      order
      ressources {
        titre
        lien
        media {
          url
        }
        type {
          nom
        }
      }
    }
  }
`;
